import type { AdlSectionExtended, CarePlan } from '@lmc/ts-common'

/** PBS template rows plus optional structured care-plan sections (custom / EOL). */
type CarePlanSectionRow = AdlSectionExtended & { sectionType?: string }

export const getSectionsToSave = (
  sectionsFromForm: AdlSectionExtended[] = [],
  formSections: Record<string, string>
) => {
  return sectionsFromForm.map((section: AdlSectionExtended) => ({
    ...section,
    value: formSections?.[section?.key || 0]
  }))
}

export const getDefaultPBSSections = (assessment: CarePlan) => {
  return assessment?.carePlanAdl?.sections?.map(
    (section: AdlSectionExtended) => ({
      ...section,
      value: ''
    })
  )
}

export const getFormSectionsInitialValue = (assessment: CarePlan) => {
  const rows = (assessment?.sections ?? []) as CarePlanSectionRow[]
  const flatSections = rows.filter((section) => !section.sectionType)
  const entries = new Map(
    flatSections.map((section) => [section.key, section.value])
  )

  const sections = Object.fromEntries(entries)

  return sections
}
